import * as yup from "yup";

export interface IFilterRangeFormValues {
  min: number | null;
  max: number | null;
}

const rangeNumberRule = yup
  .number()
  .typeError("Must be a number")
  .positive("Must be a positive number")
  .integer("Must be an integer")
  .nullable()
  .defined();

export const filterRangeSchema: yup.ObjectSchema<IFilterRangeFormValues> = yup
  .object({
    min: rangeNumberRule.test(
      "min-le-max",
      "Min must be ≤ Max",
      function (value) {
        const { max } = this.parent as IFilterRangeFormValues;
        if (typeof value !== "number" || typeof max !== "number") {
          return true;
        }
        return value <= max;
      }
    ),
    max: rangeNumberRule.test(
      "max-ge-min",
      "Max must be ≥ Min",
      function (value) {
        const { min } = this.parent as IFilterRangeFormValues;
        if (typeof value !== "number" || typeof min !== "number") {
          return true;
        }
        return value >= min;
      }
    ),
  })
  .defined();
